
import { defineComponent } from "vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "InquiryCheck",
  data() {
    return {
      verifyId: "",
      loading: false,
      error: "",
      result: null as any
    };
  },
  mounted() {
    const id = this.$route.query.id;
    if (typeof id === "string" && id.trim()) {
      this.verifyId = id.trim();
      this.checkInquiry();
    }
  },
  methods: {
    async checkInquiry() {
      const id = this.verifyId.trim();
      this.error = "";
      this.result = null;

      if (!id) {
        this.error = "Баталгаажуулах код оруулна уу.";
        return;
      }

      this.loading = true;
      try {
        const { data } = await ApiService.query("inquiry-check", {
          params: { id }
        });
        if (data.code !== 1) {
          this.error = data.error || "Лавлагаа шалгахад алдаа гарлаа.";
          return;
        }
        this.result = data.response;
      } catch (e) {
        this.error = "Сервертэй холбогдоход алдаа гарлаа.";
      } finally {
        this.loading = false;
      }
    },
    kindLabel(kind: string) {
      return kind === "RELATED"
        ? "Холбогдох этгээдийн лавлагаа"
        : "Үндсэн зээлдэгчийн лавлагаа";
    }
  }
});
